// 對應 CustomizeModel.FormType的列舉
export class InvoiceType {
  static get DuplicateUniformInvoice () {
    return 1
  }
  static get TriplicateUniformInvoice () {
    return 2
  }
  static get DuplicateCashRegisterUniformInvoice () {
    return 3
  }
  static get TriplicateCashRegisterUniformInvoice () {
    return 4
  }
  static get ComputerUniformInvoice () {
    return 5
  }
  static get ExemptionOfUniformInvoice () {
    return 6
  }
  static get ElectronicInvoice () {
    return 7
  }

  static getFormTypeName (InvoiceType) {
    let tmpType = parseInt(InvoiceType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '二聯式(手開式)'
        break
      case 2:
        name = '三聯式(手開式)'
        break
      // case 3:
      //   name = '二聯式收銀機發票'
      //   break
      // case 4:
      //   name = '三聯式收銀機發票'
      //   break
      // case 5:
      //   name = '電子計算機發票'
      //   break
      // case 6:
      //   name = '免用統一發票'
      //   break
      case 7:
        name = '電子發票'
        break
    }
    return name
  }
}
